<template>
  <div class="maintain">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: 'mydevice' }"
        >我的设备</el-breadcrumb-item
      >
      <el-breadcrumb-item>维护记录</el-breadcrumb-item>
    </el-breadcrumb>
    <el-divider />
    <div class="main">
      <div
        class="main_cell fr ac jsb pt20 pb20 cursor"
        v-for="i in maintain_list"
        :key="i.device_record_id"
        @click="go(`maintainDetail?id=${i.device_record_id}`)"
      >
        <div class="fr ac">
          <p>【{{ i.record_type == "1" ? "安装记录" : "保养记录" }}】</p>
          <p v-if="i.record_type == '1'">
            机器名:{{ i.goods_name }} {{ i.goods_standard_name }}
          </p>
          <p v-else>{{ i.record_desc }}</p>
        </div>
        <p>{{ i.record_time.substr(0, 10) }}</p>
      </div>
      <div class="fr ac jc">
        <el-pagination
          layout="prev, pager, next"
          :total="total"
          :current-page.sync="page"
          class="mt20 mb20"
          background
          :hide-on-single-page="true"
        />
      </div>
    </div>
  </div>
</template>

<script>
import UpLoad from "@/components/UploadImg";
export default {
  props: {},
  data() {
    return { total: 0, page: 1, maintain_list: [] };
  },
  created() {
    this.getDeviceRecords();
  },
  watch: {
    page(n) {
      this.getDeviceRecords();
    },
  },
  methods: {
    getDeviceRecords() {
      this.post("companyInterfaces/v1.0/getCompanyDeviceRecords", {
        member_device_id: this.$route.query.id,
        page: this.page,
      }).then((res) => {
        this.maintain_list = res.data;
        this.total = res.total;
      });
    },
  },
};
</script>

<style scoped lang="scss">
.maintain {
  font-size: 14px;
  .main {
    .main_cell {
      border-bottom: 1px solid #e5e5e5;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/page/me/myDevice/maintain.vue